import { Button, Group, Text } from "@mantine/core";
import { ConfirmAndExecutePanel, DBStatusResult, Entity, EntityClientAction } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { DatosServiciosAutorizacionProductos } from "./DatosServiciosAutorizacionProductos";

export const ACTAutorizarReporteCompleto: EntityClientAction = {
    name: 'ACTAutorizarReporteCompleto',
    label: 'Autorizar Reporte',
    title: <Text fw={700}>Autorizar Reporte</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: ['dasp_brwAutorizacionGeneral', 'dasp_brwAutorizacionGeneralAppSupervisor'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const datosServicioAutorizacionProductos = entity as DatosServiciosAutorizacionProductos;

        const procParms = {
            c_cliente_id: selectedKeys?.[0]?.['c_cliente_id'] ?? '',
            c_servicio_id: selectedKeys?.[0]?.['c_servicio_id'] ?? '',
            c_producto_id: selectedKeys?.[0]?.['c_producto_id'] ?? '',
            c_visita_id: selectedKeys?.[0]?.['c_visita_id'] ?? '',
            c_datos_servicio_set_id: selectedKeys?.[0]?.['c_datos_servicio_set_id'] ?? '',
        };

        let errores = '';

        if (!procParms.c_cliente_id || !procParms.c_servicio_id || !procParms.c_visita_id) {
            errores = 'Los registros seleccionados son inválidos';
        }

        if (errores) {
            await modal.open({
                modalProps: {
                    title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">ERROR</Text></Group>,
                },
                focusOnClosed: element,
                content:
                    <>
                        <Text size="sm" mb="xs">
                            {errores}
                        </Text>
                        <Group mt="xs" position="right">
                            <Button onClick={async () => await modal.close()}>Cerrar</Button>
                        </Group>
                    </>
            });

        }
        else {
            const abort_controller = new AbortController();

            await modal.open({
                modalProps: {
                    title: <Text fw="700">Autorizar Reporte</Text>
                },
                focusOnClosed: element,
                content: <ConfirmAndExecutePanel
                    content={<Text size="sm" mb="xs">Va a autorizar el reporte. ¿Está seguro?</Text>}
                    operation="proc"
                    onCancel={async () => { await abort_controller.abort(); await modal.close(); }}
                    onOK={
                        async (): Promise<DBStatusResult> => {
                            const reportes = Entity.clone(datosServicioAutorizacionProductos) as DatosServiciosAutorizacionProductos;

                            reportes.def.columns.c_cliente_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_cliente_id.name] as string;
                            reportes.def.columns.c_servicio_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_servicio_id.name] as string;
                            reportes.def.columns.c_producto_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_producto_id.name] as string;
                            reportes.def.columns.c_visita_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_visita_id.name] as string;

                            const result = await reportes.API.executeProcess(datosServicioAutorizacionProductos.def.procs.dasp_AutorizarReporteCompleto, procParms, abort_controller.signal, selectedKeys);

                            if (!result.Failed) {
                                if (onClose) await onClose();
                                await modal.close();
                            }

                            return result;
                        }
                    }
                />

            });
        }

        return false;
    }
}